import { Injectable } from '@angular/core'
import { MessageService } from '@mprep/shared/core/services'
import { Message } from '@mprep/shared/core/models'
import { Observable } from 'rxjs/Observable'

@Injectable()
export class PopupNotificationService {
  public message: Message

  constructor(private _messageService: MessageService) {
    this.getExpiringNotifications()
  }

  public getExpiringNotifications() {
    this._messageService.onMessageReceived().subscribe((message) => {
      if (message.topic === 'expiration') {
        this.message = message
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/popup-notification/popup-notification.service.ts